// extracted by mini-css-extract-plugin
module.exports = {"row":"components-lastUsedInfo-lastUsedInfo__row--9KnIa","icon":"components-lastUsedInfo-lastUsedInfo__icon--3zst3"};